<section
  class="home-knowledge-entities"
  data-section-id="homeia_home_knowledge_entities"
  *ngIf="featureAvailable"
>
  <header class="hk-header">
    <h3 class="hk-title">{{ lang.translate('home.knowledgeEntities.title') }}</h3>
    <a class="hk-link" [routerLink]="knowledgeLink">
      {{ lang.translate('home.knowledgeEntities.viewAll') }}
    </a>
  </header>

  <ul class="hk-list" *ngIf="!loading && !hasError && !isEmpty; else hkState">
    <li class="hk-item" *ngFor="let item of items">
      <a class="hk-name" [routerLink]="knowledgeLink">{{ item.name }}</a>
      <span class="hk-type">{{ item.type }}</span>
      <span class="hk-meta">
        {{ item.lastSeenAt | date: 'mediumDate' }}
        · {{ item.sourceCount }} {{ lang.translate('home.knowledgeEntities.sources') }}
      </span>
      <!-- Capacidades de entidad (H10/H11/H12): aisladas; su fallo nunca tumba el radar. -->
      <app-home-entity-actions class="hk-actions" [entity]="item"></app-home-entity-actions>
    </li>
  </ul>

  <ng-template #hkState>
    <div class="hk-error" *ngIf="hasError; else hkNonError">
      <p class="hk-error-title">{{ lang.translate('home.knowledgeEntities.errorTitle') }}</p>
      <p class="hk-error-message">{{ lang.translate('home.knowledgeEntities.errorMessage') }}</p>
      <button type="button" class="btn btn-outline-primary" (click)="onRetry()">
        {{ lang.translate('home.general.retry') }}
      </button>
    </div>
    <ng-template #hkNonError>
      <div class="hk-empty" *ngIf="isEmpty; else hkLoading">
        {{ lang.translate('home.knowledgeEntities.empty') }}
      </div>
      <ng-template #hkLoading>
        <div class="hk-loading" role="status">{{ lang.translate('home.general.loading') }}</div>
      </ng-template>
    </ng-template>
  </ng-template>
</section>
